import React from "react";
import styles from "./BasicInput.module.css";

const BasicInput = ({ wrapperProps, label, labelProps, id, required, ...props }) => {
  return (
      <div
          {...wrapperProps}
          className={[styles.inputWrapper, wrapperProps?.className].join(" ")}
      >
        {label && (
            <label
                htmlFor={id || label}
                {...labelProps}
                className={[styles.label, labelProps?.className].join(" ")}
            >
              {label} {required && <span className={styles.required}>*</span>}
            </label>
        )}
        <input
            id={id || label}
            {...props}
            required={required}
            className={[styles.input, props?.className].join(" ")}
        />
      </div>
  );
};

export default BasicInput;